import React, { useState, useEffect, useRef } from "react";
import Layout from "./layout";
import { useNavigate } from "react-router-dom";
import Col from "react-bootstrap/Col";
import DateInput from "../components/DateInput";
import Button from "../components/Button";
import { Row } from "react-bootstrap";
import SearchBar from "../components/Searchbar";
import visitorsData from "../assets/json/analyticsData.json";
import trafficRawData from "../assets/json/trafficdata.json";
import VisitorsChartComponent from "../components/VisitorsChart";
import ChartComponent from "../components/TraficChart";
import LoadTimeChart from "../components/LoadTimeChartComponent";
import loadTimeData from "../assets/json/loadTime.json";
import { callback } from "chart.js/helpers";
import GaugeChartComponent from "../components/GaugeChartComponent";



const AnalyticsReport = () => {
    const navigate = useNavigate();
    const handleRefresh = () => {
        window.location.reload(); // This will refresh the page
    };

    const [visitors, setVisitors] = useState([]);
    const [traffic, setTraffic] = useState([]);

    useEffect(() => {
        // Simulate API or local file loading
        setVisitors(visitorsData);
        setTraffic(trafficRawData);
    }, []);


    // ======= Visitor Chart Setup =======
    const visitorLabels = visitors.map(entry =>
        new Date(entry.date).toLocaleDateString('en-US', { weekday: 'short' })
    );

    const visitorChartData = {
        labels: visitorLabels,
        datasets: [
            {
                label: "Total Visitors",
                data: visitors.map(entry => entry.total_visitors),
                borderColor: "#a78bfa",
                backgroundColor: "#a78bfa",
                tension: 0.1,
                fill: false,
            },
            {
                label: "Unique Visitors",
                data: visitors.map(entry => entry.unique_visitors),
                borderColor: "#f59e0b",
                backgroundColor: "#f59e0b",
                tension: 0.1,
                fill: false,
            },
            {
                label: "Page Views",
                data: visitors.map(entry => entry.page_views),
                borderColor: "#3b82f6",
                backgroundColor: "#3b82f6",
                tension: 0.1,
                fill: false,
            },
            {
                label: "Sessions",
                data: visitors.map(entry => entry.sessions),
                borderColor: "#ec4899",
                backgroundColor: "#ec4899",
                tension: 0.1,
                fill: false,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    usePointStyle: true,
                    pointStyle: "circle",
                    padding: 20,
                },
            },
            tooltip: {
                enabled: true, // ❌ Turn off tooltip if you also don't want hover values
            },
            datalabels: {
                display: false, // ⛔ Explicitly disable data labels if plugin is registered
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 1000,
                    callback: (value) => (value >= 1000 ? value / 1000 + "k" : value),
                },
            },
        },
    };

    // ======= load Time Setup =======

    const loadTimeLabels = loadTimeData.map(entry => entry.page);
    const desktopTimes = loadTimeData.map(entry => entry.desktop);
    const laptopTimes = loadTimeData.map(entry => entry.laptop);

    const loadTimeChartData = {
        labels: loadTimeLabels,
        datasets: [
            {
                label: "Desktop",
                data: desktopTimes,
                backgroundColor: "#a78bfa",
            },
            {
                label: "Mobile",
                data: laptopTimes,
                backgroundColor: "#3b82f6",
            }
        ]
    };

    const loadTimeOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    usePointStyle: true,
                    pointStyle: "circle",
                    padding: 20,
                },
            },
            tooltip: {
                enabled: true, // ❌ Turn off tooltip if you also don't want hover values
            },
            datalabels: {
                display: false, // ⛔ Explicitly disable data labels if plugin is registered
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 30,
                    callback: function (value) {
                        return value + " ms"; // or " sec" if you're using seconds
                    }
                },
            },

        }
    };


    return (
        <Layout>

            <div className="d-flex align-items-center justify-content-between">

                <div className="mt-3 d-flex align-items-center">
                    <div className="d-flex gap-5 md-date">
                        <DateInput label="" type="range" includeTime={false} />
                    </div>

                    {/* Refresh Button */}
                    <div className=" mb-2 ps-3 md-refresh ">
                        <i
                            className="bi bi-arrow-repeat icon-refresh"
                            onClick={handleRefresh}
                        ></i>
                    </div>
                </div>
                <div className="text-right gap-3 ie-btn d-flex">
                    <Button
                        buttonType="^"
                        onClick={() => navigate("/add-usersegment")}
                        label="User Segment"
                    />

                </div>

            </div>
            <div>
                <SearchBar />
            </div>
            <br></br>

            <Row>
                <Col md={7}>
                    <div style={{ background: "#fff", padding: "20px", borderRadius: "12px" }}>
                        <h3>Traffic Metrix</h3>
                        <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "4px" }}>
                            <button style={{
                                padding: "6px 12px",
                                border: "none",
                                background: "#ffffff",
                                borderRadius: "6px",
                                marginRight: "4px",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: 500,
                            }}>Days</button>
                            <button style={{
                                padding: "6px 12px",
                                border: "none",
                                background: "transparent",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: 500,
                            }}>Month</button>
                            <button style={{
                                padding: "6px 12px",
                                border: "none",
                                background: "transparent",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: 500,
                            }}>Year</button>
                        </div>
                        <VisitorsChartComponent
                            data={visitorChartData}
                            options={options}
                        />
                    </div>
                </Col>

                <Col md={5}>
                    <div style={{ background: "#fff", padding: "20px", borderRadius: "12px" }}>
                        <h3>Traffic Sources</h3>
                        <ChartComponent />

                    </div>
                </Col>

            </Row>

            <Row>
                <Col md={7}>
                    <div style={{ marginTop: "20px" }}>
                        <LoadTimeChart
                            data={loadTimeChartData}
                            options={loadTimeOptions}
                        />
                    </div>

                </Col>

                <Col md={5}>
                    <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", marginTop: "20px" }}>
                        <h3>Bounce Rate</h3>
                        <button className="bounce-rate">82.67%</button>
                        <GaugeChartComponent />
                    </div>
                </Col>
            </Row>
        </Layout>
    );
};

export default AnalyticsReport;

